import { Link } from "react-router-dom";
import ComicCard from "@/components/base/ComicCard";
import { getFeaturedComics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";

export default function FeaturedComics() {
  const featured = getFeaturedComics();

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-1 h-5 rounded-full bg-primary-500" />
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                精选推荐
              </h2>
            </div>
            <p className="text-foreground-500 text-sm">
              编辑精心挑选的高评分韩漫，每一部都值得细细品味
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.slice(1, 6).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 text-xs rounded-full bg-background-200/70 text-foreground-400 hover:text-primary-500 hover:bg-primary-500/10 border border-background-300/40 hover:border-primary-500/30 transition-all duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {featured.map((comic) => (
            <div key={comic.id} className="flex justify-center">
              <ComicCard comic={comic} size="large" />
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-300/50 text-foreground-300 hover:text-foreground-50 hover:border-foreground-50/50 text-sm transition-all duration-300 whitespace-nowrap"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}